import tw from "tailwind-styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getRoundDaysText(_ref) {
  let {
    roundStartsIn,
    roundEndsIn
  } = _ref;
  const dayTerm = getSingularPlural(["day", "days"]);
  if (roundStartsIn !== undefined && roundStartsIn > 0) {
    return `Starts in ${roundStartsIn} ${dayTerm(roundStartsIn)}`;
  }
  if (roundEndsIn === undefined) return "No round end date";
  if (roundEndsIn === 0) return "Ends today";
  return roundEndsIn > 0 ? `${roundEndsIn} ${dayTerm(roundEndsIn)} left in round` : `Ended ${-roundEndsIn} ${dayTerm(-roundEndsIn)} ago`;
}
export function getRoundApplicationDaysText(_ref2) {
  let {
    applicationsStartsIn,
    applicationsEndsIn
  } = _ref2;
  const dayTerm = getSingularPlural(["day", "days"]);

  // Hide if application date has passed
  if (applicationsEndsIn === undefined || applicationsEndsIn < 0) return "";
  if (applicationsEndsIn === 0) return "Last day to apply";
  if (applicationsStartsIn !== undefined && applicationsStartsIn > 0 && applicationsEndsIn > 0) {
    return `Apply in ${applicationsStartsIn} ${dayTerm(applicationsStartsIn)}`;
  }
  return `${applicationsEndsIn} ${dayTerm(applicationsEndsIn)} left to apply`;
}
export const RoundDaysDetails = _ref3 => {
  let {
    roundStartsIn,
    roundEndsIn,
    applicationsStartsIn,
    applicationsEndsIn
  } = _ref3;
  const startsOrEndsIn = getRoundDaysText({
    roundStartsIn,
    roundEndsIn
  });
  const applicationsIn = getRoundApplicationDaysText({
    applicationsStartsIn,
    applicationsEndsIn
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-1",
    children: [/*#__PURE__*/_jsx(Days, {
      "data-testid": "apply-days-left",
      children: applicationsIn
    }), /*#__PURE__*/_jsx(Days, {
      "data-testid": "days-left",
      children: startsOrEndsIn
    })]
  });
};
const Days = tw.div`
text-xs
w-full
font-mono
whitespace-nowrap
`;

// If we need something more advanced or to use in another place in codebase, we can pull in a library
const getSingularPlural = _ref4 => {
  let [singular = "", plural = ""] = _ref4;
  return function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return num ? num === 1 ? singular : plural : plural;
  };
};